import { CreateColumnResponse, UpdateMetricResponse } from 'tabs/data/api/generated'
import {
  CreateDatasetColumnsParams,
  createTableColumn,
  UpdateDatasetColumnsParams,
  updateTableColumn,
} from 'tabs/data/api/columns'

type UseDatasetTablesParams = {
  createColumn: (
    datasetId: string,
    tableId: string,
    params: CreateDatasetColumnsParams,
  ) => Promise<CreateColumnResponse>
  updateColumn: (
    columnId: string,
    datasetId: string,
    tableId: string,
    force: boolean,
    params: UpdateDatasetColumnsParams,
  ) => Promise<UpdateMetricResponse>
}

export const useDatasetColumns = (): UseDatasetTablesParams => {
  const createColumn = async (
    datasetId: string,
    columnId: string,
    params: CreateDatasetColumnsParams,
  ): Promise<CreateColumnResponse> => {
    return createTableColumn(datasetId, columnId, params)
  }

  const updateColumn = async (
    columnId: string,
    datasetId: string,
    tableId: string,
    force: boolean,
    params: UpdateDatasetColumnsParams,
  ) => {
    return updateTableColumn(columnId, datasetId, tableId, force, params)
  }

  return { createColumn, updateColumn }
}
